import topicScenarioLoader from "./topicScenarioLoader";
import { mapGetters } from "vuex";

export default {
  mixins: [topicScenarioLoader],

  computed: {
    ...mapGetters(["getCurrentTopicId"]),

    topicIndex: {
      get() {
        if (!this.getCurrentTopicId || this.topics.length === 0) return -1;
        return this.topics.findIndex((t) => t.id === this.getCurrentTopicId);
      },
      set(value) {
        if (value >= 0 && value < this.topics.length) {
          this.handleSelectTopic(this.topics[value].id);
        }
      },
    },

    scenarioIndex: {
      get() {
        if (!this.selectedScenarioId || this.scenarios.length === 0) return -1;
        return this.scenarios.findIndex(
          (s) => s.id === this.selectedScenarioId
        );
      },
      set(value) {
        if (value >= 0 && value < this.scenarios.length) {
          this.handleSelectScenario(this.scenarios[value].id);
        }
      },
    },
  },

  watch: {
    selectedTopicId: {
      handler(newId) {
        if (newId) {
          this.topicIndex = this.topics.findIndex((t) => t.id === newId);
        } else {
          this.topicIndex = -1;
        }
      },
      immediate: true,
    },

    selectedScenarioId: {
      handler(newId) {
        if (newId) {
          this.scenarioIndex = this.scenarios.findIndex((s) => s.id === newId);
        } else {
          this.scenarioIndex = -1;
        }
      },
      immediate: true,
    },

    topicIndex: {
      handler(newIndex) {
        if (newIndex >= 0 && this.topics[newIndex]) {
          this.handleSelectTopic(this.topics[newIndex].id);
        }
      },
    },

    scenarioIndex: {
      handler(newIndex) {
        if (newIndex >= 0 && this.scenarios[newIndex]) {
          this.handleSelectScenario(this.scenarios[newIndex].id);
        }
      },
    },
  },

  methods: {
    async handleNavigateTopic(delta) {
      if (this.topics.length === 0) return;

      let newIndex = this.topicIndex + delta;

      // Loop around
      if (newIndex < 0) {
        newIndex = this.topics.length - 1;
      } else if (newIndex >= this.topics.length) {
        newIndex = 0;
      }

      this.topicIndex = newIndex;
    },

    handleNavigateScenario(delta) {
      if (this.scenarios.length === 0) return;

      let newIndex = this.scenarioIndex + delta;

      // Loop around
      if (newIndex < 0) {
        newIndex = this.scenarios.length - 1;
      } else if (newIndex >= this.scenarios.length) {
        newIndex = 0;
      }

      this.scenarioIndex = newIndex;
    },
  },
};
